import React, { Component } from 'react'
import { connect } from 'react-redux'

import { Button, PageLoader } from 'component-library-next'

import Input from '@app/common/Components/Inputs/Input'
import AuthAction from '@app/modules/Auth/actions'
import UnAuthLogo from '@app/modules/Auth/Components/Logos/UnAuthLogo'
import RentalIssue from '@app/modules/Auth/Components/RentalIssue'
import { validateEmail } from '@app/modules/Auth/helpers/validateEmail'

import './style.scss'

class LoginPage extends Component {
  state = {
    email: '',
    password: '',
    emailError: '',
    passwordError: ''
  }

  componentWillReceiveProps(nextProps) {
    const { sending, loginError } = nextProps

    if (nextProps !== this.props && !sending) {
      if (loginError) {
        this.setState({
          passwordError: 'Falscher Benutzername oder Passwort, bitte versuchen Sie es erneut'
        })
      }
    }
  }

  onInputChange = (e) => {
    const { type, value } = e.currentTarget

    this.setState({
      [type]: value,
      [`${type}Error`]: ''
    })
  }

  handleSubmit = (e) => {
    e.preventDefault()

    const { email, password } = this.state

    const validEmail = validateEmail(email)
    const validPassword = password.length > 0
    const allowSendingData = validEmail && validPassword

    !validEmail && this.setState({ emailError: 'Bitte gib eine gültige Email-Adresse ein.' })
    !validPassword && this.setState({ passwordError: 'Bitte gib dein Passwort ein.' })

    allowSendingData && this.props.login({ email, password })
  }

  render() {
    const { emailError, passwordError } = this.state

    const { sending } = this.props

    return (
      <div className='auth login'>
        {sending ? <PageLoader loading /> : null}

        <div className='auth-content'>
          <header>
            <UnAuthLogo />
          </header>

          <div className='greeting'>
            <h2 className='auth-heading-2'>Willkommen bei MieterEngel!</h2>
            <p>MieterEngel ist der digitale Mieterschutz-Club</p>
          </div>

          <form action='' onSubmit={this.handleSubmit}>
            <div className='form-content'>
              <Input
                placeholder='Email'
                type='email'
                onChange={this.onInputChange}
                error={emailError}
                testId='lawyer__login__username'
              />
              <Input
                placeholder='Passwort'
                type='password'
                onChange={this.onInputChange}
                error={passwordError}
                testId='lawyer__login__password'
              />
            </div>

            <p style={{ marginBottom: 17 }}>
              <Button disabled={false} type={Button.types.submit} testId='lawyer__login__submit'>
                Einloggen
              </Button>
            </p>
          </form>
        </div>
        <RentalIssue />
      </div>
    )
  }
}

const ConnectedLoginPage = connect(({ auth }) => ({ ...auth }), { login: AuthAction.login })(
  LoginPage
)

export { ConnectedLoginPage as LoginPage }
